import Nav from "./Nav";
import Footer from "./Footer";
import AIChat from "../AIChat";
import CompareBar from "../CompareBar";
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { organizationSchema, websiteSchema } from "../../lib/schema";

export default function PublicLayout() {
  const location = useLocation();
  // Home hero extends behind the transparent nav, so the home page manages
  // its own top-padding. Every other route keeps the classic 80px offset.
  const isHome = location.pathname === "/";
  return (
    <div className="min-h-screen bg-white text-[#050d19]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
        <script type="application/ld+json">{JSON.stringify(websiteSchema())}</script>
      </Helmet>
      <Nav />
      <main className={isHome ? "" : "pt-20"}>
        <Outlet />
      </main>
      <Footer />
      <CompareBar />
      <AIChat />
    </div>
  );
}
